/**
 * Garante que a ação "Alterar a Solicitação" (tipo_acao=4) esteja no catálogo do chatbot.
 */
export const ALTERAR_SOLICITACAO_ACTION = {
  tipo_acao: 4,
  id_acao: 4,
  value: "4-4",
  label: "Alterar a Solicitação",
  description:
    "Atualiza a solicitação em atendimento (transferência, status, tipo, subtipos, fixação etc.).",
  supported: true,
  group: "lead",
  hasParameters: true,
  searchText:
    "alterar solicitação solicitação transferir usuário chatbot agente ia status tipo subtipo fixar fixação lead mudar",
};

export function ensureAlterarSolicitacaoAction(actions = [], parameterForm = null) {
  const list = Array.isArray(actions) ? [...actions] : [];
  const idx = list.findIndex((a) => Number(a.tipo_acao) === 4 && Number(a.id_acao) === 4);

  if (idx === -1) {
    list.unshift({
      ...ALTERAR_SOLICITACAO_ACTION,
      parameterForm: parameterForm || null,
    });
    return list;
  }

  const current = list[idx];
  if (parameterForm && !current.parameterForm) {
    const copy = [...list];
    copy[idx] = { ...current, parameterForm };
    return copy;
  }

  return list;
}
